import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";
import { Input } from "@/components/ui/Input";
import { useState } from "react";

interface AddBudgetRowDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAddRow: (accountName: string, accountNumber: number) => void;
}

export const AddBudgetRowDialog = ({
  open,
  onOpenChange,
  onAddRow,
}: AddBudgetRowDialogProps) => {
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const handleCreate = () => {

    if (accountName.trim() && IsAccountNumberValid()) {
      onAddRow(accountName, GetAccountNumberNumber());
      setAccountName("");
      setAccountNumber("");
      onOpenChange(false);
    }
  };

  const IsAccountNumberValid = () => {
    const accNo = GetAccountNumberNumber();
    if ((typeof Number(accNo) !== "number"))
      return false;
    if (accNo < 3000 || accNo > 8999)
      return false;

    return true;
  }

  const GetAccountNumberNumber = () => Number(accountNumber);

  return (
    <Dialog
      open={open}
      onClose={() => onOpenChange(false)}
      title="Add budget row"
      footer={
        <>
          <Button variant="outlined" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleCreate} disabled={!accountName.trim() || !IsAccountNumberValid()}>
            Add
          </Button>
        </>
      }
    >
      <div className="space-y-6 py-4">
        <div className="space-y-2">
          <Input
            label="Account number"
            placeholder="Account number"
            type="number"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
          />
          <Input
            label="Account name"
            placeholder="New budget"
            value={accountName}
            onChange={(e) => setAccountName(e.target.value)}
          />
        </div>
      </div>
    </Dialog>
  );
};